export const addCommas = (week: any, field: string) => {
  const measures = [
    'AccountConstrainedFWOS',
    'AccountTargetFWOS',
    'DistiConstrainedFWOS',
    'FBProjectedFWOS',
  ];
  if (
    !measures.includes(field) &&
    field.indexOf('Comment') < 0 &&
    week[field] &&
    week[field].toString().indexOf('-') < 0 &&
    field.indexOf('Pct') < 0
  ) {
    week[field] = week[field] ? week[field].toString() : '';
    week[field] = week[field].replaceAll(',', '');
    week[field] = Math.round(Number(week[field])).toLocaleString('en');
    return week[field];
  } else if (week[field] !== 'Multiple' && measures.includes(field)) {
    week[field] = week[field] ? week[field].toString() : '';
    week[field] = week[field].replaceAll(',', '');
    week[field] = Number(Number(week[field]).toFixed(2)).toLocaleString('en');
  }
  return week[field];
};
